import { Link } from "easy-page-router/react";
import { useHead } from "../services/common";

import { useLang } from "../components/Language";
import Footer from "../components/Footer";
import { Header } from "../components";
import Content from "../components/Content";

export default function Evenings() {
    const lang = useLang();

    const title = lang === "cs" ? "Krakonošovy letní podvečery" : "Letnie wieczory z karkonoskim duchem";
    useHead(title, `${title} | Jilemnicko - společenství obcí`);

    return <>
        <Header title={title} background="podvecery" />
        <main className="evenings">
            <section className="content-page">
                <h1 className="hidden">{title}</h1>
                <div className="content-split">
                    <div className="left">
                        <Content id="evenings-top" />
                        <Link className="button" to="/rezervace-jarmarecniho-stanku">Rezervace jarmarečního stánku</Link>
                    </div>
                    <div className="right evenings-images" />
                </div>

                <div className="image-main" />
                <Content id="evenings" />
            </section>
        </main>
        <Footer />
    </>;
}
